import type { PayloadError } from 'relay-runtime';
import { v4 as uuid } from 'uuid';
import { useExperienceFail } from '@atlassian/jira-experience-tracker/src/ui/experience-fail/index.tsx';
import { useExperienceStart } from '@atlassian/jira-experience-tracker/src/ui/experience-start/index.tsx';
import { useExperienceSuccess } from '@atlassian/jira-experience-tracker/src/ui/experience-success/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JIRA_SOFTWARE } from '@atlassian/jira-shared-types/src/application.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import type { Attributes } from '../../common/types.tsx';

export type SuccessExperienceCallback = (attributes?: Attributes) => void;

export type FailExperienceCallback = (
	location: string,
	error: Error | PayloadError[],
	attributes: Attributes,
) => void;

export const useExperienceTracker = (experience: string, analyticsSource: string) => {
	const { appEditions } = useTenantContext();

	const onExperienceStart = useExperienceStart({
		experienceId: uuid(),
		experience,
		analyticsSource,
		edition: appEditions.software,
		application: JIRA_SOFTWARE,
	});

	const onExperienceSuccess = useExperienceSuccess({
		experience,
		attributes: {
			synthetic: fg('is_synthetic_tenant'),
		},
	});

	const onExperienceFail = useExperienceFail({
		experience,
		attributes: {
			synthetic: fg('is_synthetic_tenant'),
		},
	});

	return [onExperienceStart, onExperienceSuccess, onExperienceFail] as const;
};
